<script lang="ts">
	import AnimatedBackground from "../../reusable/AnimatedBackground.svelte"
	import { LoginControler } from "./LoginController"
	import LoginPage from "./LoginPage.svelte"
	import RequestPasswordReset from "./RequestPasswordReset.svelte"

	import "../../../assets/css/login.css"
	import ResetPassword from "./ResetPassword.svelte"
	import { onMount } from "svelte"
	import { Tooltip } from "tooltip"
	import { Toaster } from "toaster"
	import { getCurrentUser } from "../../../stores/UserStore.svelte"
	import { navigate } from "svelte-routing"

	let currentState: "login" | "reset_request" | "reset_password" = $state("login")

	LoginControler.subscribe((s) => (currentState = s))

	const componentMap = {
		login: LoginPage,
		reset_request: RequestPasswordReset,
		reset_password: ResetPassword,
	}

	onMount(() => {
		const urlParams = new URLSearchParams(window.location.search)
		const token = urlParams.get("_reset_token")
		const email = urlParams.get("_reset_email")

		if (token && email) {
			LoginControler.initResetPassword(token, email)
		}

		if (getCurrentUser()) navigate("projector")
	})
</script>

<div id="login-page">
	<AnimatedBackground />
	{#if currentState}
		{@const ActiveComponent = componentMap[currentState]}
		<ActiveComponent />
	{/if}
</div>

<Tooltip />
<Toaster topMargin="1rem" />

<style>
	#login-page {
		width: 100dvw;
		height: 100dvh;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
	}
</style>
